export default "__VITE_ASSET__DzV0e2UW__"